import { http } from "@/lib/http";

export function fetchAnnouncements() {
  return http.get("/api/announcements/get_all").then((res) => res.data);
}
export function fetchAnnouncement(id) {
  return fetchAnnouncements().then(
    (list) => list.find((a) => a._id === id) ?? null,
  );
}
export function fetchTopics() {
  return http.get("/api/topics/get_all").then((res) => res.data);
}
export function addAnnouncement(payload) {
  return http.post("/api/announcements/add", payload).then((res) => res.data);
}
export function editAnnouncement(id, payload) {
  return http
    .post(`/api/announcements/edit/${id}`, payload)
    .then((res) => res.data);
}
export function deleteAnnouncement(id) {
  return http.delete(`/api/announcements/delete/${id}`).then((res) => res.data);
}
export function fetchAnnouncementReadNames(id) {
  return http
    .post("/api/announcements/get_names", { docId: id })
    .then((res) => res.data);
}
export function sendTopicNotification(payload) {
  return http
    .post("/api/notifications/send_notif/topic", payload)
    .then((res) => res.data);
}
